const MyQuizTemplateAvailableCategories = ({ passedCategories }) => {
  const classBannerCategoriesContent = passedCategories.map((passedCategory) => {
    return (
      <div
        key={passedCategory.id}
        className="px-[16px] py-[10px] bg-[#FDFDFD] rounded-[6px] text-sm leading-[20px] font-bold text-primary-100"
      >
        {passedCategory.name}
      </div>
    )
  })

  return (
    <div className="w-full bg-[#FEEBDD] rounded-[10px] p-[32px] mt-[20px]">
      <span className="text-sm font-normal text-primary-100">
        You have {passedCategories.length} {passedCategories.length > 1 ? 'categories' : 'category'}{' '}
        available{passedCategories.length ? ':' : ''}
      </span>

      {!!passedCategories.length && (
        <div className="w-full mt-[10px] flex items-start flex-wrap gap-[8px]">
          {classBannerCategoriesContent}
        </div>
      )}
    </div>
  )
}

export default MyQuizTemplateAvailableCategories
